import * as Sentry from "@sentry/browser";

const release = process.env.REACT_APP_COMMIT_SHA
  ? "freem-fine-calculator@" + process.env.REACT_APP_COMMIT_SHA
  : "freem-fine-calculator";

const environment = process.env.REACT_APP_DEPLOYMENT_ENV || "development";

function init() {
  Sentry.init({
    dsn: "https://6190f280b3544923817281909c9585eb@sentry-relay.chevalier.group/21",
    environment,
    release,
  });
}

export default init;
